import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { useEffect, useMemo, useState } from 'react';
import { TOTAL_STEPS, useProjectFormStore } from '@/lib/project-form-store';
import { ProjectNewProvider } from './-components/project-new-context';
import { ProjectNewLayout } from './-components/project-new-layout';

export const Route = createFileRoute('/ngos/projects/new')({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useLingui();
	const navigate = useNavigate();

	useEffect(() => {
		// Keep the store reset in the lazy component chunk so the route wrapper stays preload-light.
		return () => {
			useProjectFormStore.getState().reset();
		};
	}, []);

	const navigation = useMemo(
		() => ({
			toIndex: () => navigate({ to: '/ngos/projects/new' }),
			toBasic: () => navigate({ to: '/ngos/projects/new/basic' }),
			toDetails: () => navigate({ to: '/ngos/projects/new/details' }),
			toFundingType: () => navigate({ to: '/ngos/projects/new/funding-type' }),
			toFundingDetails: () => navigate({ to: '/ngos/projects/new/funding-details' }),
			toSuccess: (params?: {
				startDate?: string;
				projectId?: string;
				fundingType?: 'myPortal' | 'worldcoo' | 'both';
			}) =>
				navigate({
					to: '/ngos/projects/new/success',
					search:
						params?.startDate || params?.projectId || params?.fundingType
							? {
									startDate: params.startDate,
									projectId: params.projectId,
									fundingType: params.fundingType,
								}
							: undefined,
				}),
			toCancel: () => navigate({ to: '/ngos/projects' }),
		}),
		[navigate],
	);

	const [stepNavContainer, setStepNavContainer] = useState<HTMLDivElement | null>(null);

	return (
		<ProjectNewProvider
			value={{
				fromPortal: false,
				totalSteps: TOTAL_STEPS,
				navigation,
				breadcrumbs: [{ label: t`Projects`, onClick: navigation.toCancel }],
				stepNavContainer,
				setStepNavContainer,
			}}
		>
			<ProjectNewLayout />
		</ProjectNewProvider>
	);
}
